// extracted by mini-css-extract-plugin
export default {"host":"Host_host__asYh0","hostPhoto":"Host_hostPhoto__odp-s","hostName":"Host_hostName__ts+Cg","hostDesc":"Host_hostDesc__PN3ZN"};